import { StipendExpense, StipendExpenseStatus } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";
import { ComponentProps } from "react";

type Props = {
  stipendExpense: StipendExpense;
  size?: ComponentProps<typeof Body>["size"];
};

export const PaymentMethod = ({ stipendExpense, size = "sm" }: Props) => {
  const paymentInfo =
    stipendExpense.status === StipendExpenseStatus.Approved &&
    stipendExpense.displayPayoutMethod
      ? `Paid via ${stipendExpense.displayPayoutMethod}`
      : "";

  if (!paymentInfo) return null;

  return (
    <Body size={size} weight="medium" className="text-muted-foreground">
      {paymentInfo}
    </Body>
  );
};
